import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  return (
    <main className="min-h-screen bg-bg text-text">
      <section className="mx-auto max-w-4xl px-6 py-16">
        <span className="inline-block rounded-full border border-gold/30 bg-gold/10 px-4 py-1.5 text-sm font-semibold uppercase tracking-wider text-gold">
          Sprint 1 · Bootstrap
        </span>
        <h1 className="mt-6 text-5xl font-extrabold tracking-tight md:text-6xl">
          Derrota a la corrompida{' '}
          <span className="bg-gradient-to-r from-gold to-yellow-200 bg-clip-text text-transparent">
            monarquía.
          </span>
        </h1>
        <p className="mt-6 max-w-2xl text-lg text-text-muted">
          Réplica fan-made de Regicide. Single-player, en el browser, con stack moderno.
        </p>

        <div className="mt-10 flex flex-wrap gap-4">
          <Link
            to="/play"
            className="rounded-xl bg-gold px-6 py-3 font-semibold text-bg shadow-lg transition hover:brightness-110"
          >
            Jugar
          </Link>
          <Link
            to="/how-to-play"
            className="rounded-xl border border-border bg-transparent px-6 py-3 font-semibold text-text transition hover:border-gold hover:text-gold"
          >
            Cómo se juega
          </Link>
          <Link
            to="/saves"
            className="rounded-xl border border-border bg-transparent px-6 py-3 font-semibold text-text transition hover:border-gold hover:text-gold"
          >
            Saves
          </Link>
          <Link
            to="/leaderboard"
            className="rounded-xl border border-border bg-transparent px-6 py-3 font-semibold text-text transition hover:border-gold hover:text-gold"
          >
            Leaderboard
          </Link>
          <Link
            to="/lobby"
            className="rounded-xl border border-border bg-transparent px-6 py-3 font-semibold text-text transition hover:border-gold hover:text-gold"
          >
            Multiplayer
          </Link>
          <Link
            to="/settings"
            className="rounded-xl border border-border bg-transparent px-6 py-3 font-semibold text-text transition hover:border-gold hover:text-gold"
          >
            Ajustes
          </Link>
        </div>

        <div className="mt-16 grid gap-4 md:grid-cols-3">
          <Card title="🃏 54 cartas" desc="Mazo estándar + 2 Jokers" />
          <Card title="👥 1 jugador" desc="Modo single-player contra IA" />
          <Card title="🎯 12 enemigos" desc="Jacks, Queens y Kings" />
        </div>
      </section>
    </main>
  );
}

function Card({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="rounded-xl border border-border bg-bg-card p-6">
      <h3 className="text-lg font-semibold">{title}</h3>
      <p className="mt-1 text-sm text-text-muted">{desc}</p>
    </div>
  );
}
